import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleModal } from '../../store/ui/actions'
import Button from '../forms/Button'
import BlurOver from './BlurOver'
import Tooltip from './Tooltip'
import styles from './styles/BlurOverPaywall.css'
import { setMode } from '../../store/login-modal/actions'

const BlurOverPaywall = ({ contentType, placeholder, modalFromContext = null }) => {
  const dispatch = useDispatch()
  const user = useSelector(({ ui }) => ui.user)

  const contentTypeText = contentType
  const tooltipContent = user ? `Ugrade to see this ${contentTypeText}` : `Login to see this ${contentTypeText}`

  const handleClickBlurred = useCallback(() => {
    if (user) {
      dispatch(toggleModal('upgrade', true, modalFromContext))
      return
    }
    dispatch(setMode('register'))
    dispatch(toggleModal('login', true))
  })

  return (
    <BlurOver
      hoverEffect
      foreground={() => (
        <div className={styles.placeholderFg}>
          <Tooltip content={tooltipContent} onClick={handleClickBlurred} role='button' aria-label='Hidden snippet'>
            <span className={styles.placeholderSizer} aria-hidden>
              {placeholder}
            </span>
            <Button className={styles.unlockBtn} color='white'>
              Show {contentTypeText}
            </Button>
          </Tooltip>
        </div>
      )}
    >
      {placeholder}
    </BlurOver>
  )
}

export default BlurOverPaywall
